module.exports = __webpack_public_path__ + "static/media/14.6a8d0f9f.webp";